module.exports = __webpack_public_path__ + "static/media/opera.481c86c7.png";